let sessionExpiredHandler = null;

export const setSessionExpiredHandler = (
    handler
) => {
    sessionExpiredHandler =
        handler;
};

export const triggerSessionExpired =
    () => {
        if (
            sessionExpiredHandler
        ) {
            sessionExpiredHandler();
        }
    };